<template>
  <div ref="control" v-if="component && component.properties" :class="['report-column-edit-date', error && 'error-border', column.lineWrap && 'report-column-edit-column-normal']">
    <div :style="{'height': column.lineWrap && controlHeight}" v-if="edit && !component.properties.readonly && !component.properties.hidden" class="date">
      <el-date-picker ref="input" v-if="component.archive.dataType==='date'" v-model="formatValue" :title="formatValue" @keydown.enter.exact.stop.native="getToday" @change="updateTime" value-format="yyyy-MM-dd" type="date" :placeholder="placeholder" prefix-icon=" " clear-icon=" " @blur="edit = !!error" :editable="false">
      </el-date-picker>
      <el-time-picker ref="input" v-if="component.archive.dataType==='time'" v-model="formatValue" :title="formatValue" @keydown.enter.exact.stop.native="getToday" @change="updateTime"  value-format="HH:mm:ss" arrow-control="" :picker-options="pickerOptions" :placeholder="placeholder" prefix-icon=" " clear-icon=" " @blur="edit = !!error" :editable="false">
      </el-time-picker>
      <el-date-picker ref="input" v-if="component.archive.dataType==='dateTime'" v-model="formatValue" :title="formatValue" @keydown.enter.exact.stop.native="getToday" @change="updateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions" :placeholder="placeholder" prefix-icon=" " clear-icon=" " @blur="edit = !!error" :editable="false">>
      </el-date-picker>
    </div>
    <template v-else>
      <template v-if="component.properties.readonly || component.properties.hidden">
        <el-tooltip v-if="showTooltip" effect="dark" :content="formatter(value)" placement="top">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm">{{ formatter(value) }}</div>
        </el-tooltip>
        <div v-else class="span">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm">{{ formatter(value) }}</div>
        </div>
      </template>
      <template v-else>
        <el-tooltip v-if="showTooltip" effect="dark" :content="formatter(value)" placement="top">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm">
            {{ formatter(value) }}
            <i class="el-icon-date" @click.stop="openInput"></i>
          </div>
        </el-tooltip>
        <div v-else class="span" :style="{'line-height': !column.lineWrap && controlHeight}" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm">
          {{ formatter(value) }}
          <i class="el-icon-date" @click.stop="openInput"></i>
        </div>
      </template>
    </template>
    <!-- 这玩意禁用了文本框输入，那应该没有必填这种校验了吧。。。 -->
    <div v-if="error" class="error-message">{{ error }}</div>
  </div>
</template>

<script>
import publicMixin from './mixin'
export default {
  name: 'report-rc-date',
  mixins: [publicMixin],
  data () {
    return {
      formatValue: this.value
    }
  },
  methods: {
    updateTime (e) {
      this.value = e === null ? '' : e
      let error = this.validate()
      this.error = error
      if (!error) {
        this.error = ''
        this.edit = false
        e === null ? this.update('') : this.update(e)
      }
    },
    getToday () {
      if (this.formatValue === '' || this.formatValue === null) {
        let today = new Date()
        if (this.component.archive.dataType === 'date') {
          this.formatValue = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
        } else if (this.component.archive.dataType === 'dateTime') {
          this.formatValue = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
        } else {
          this.formatValue = today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds()
        }
      }
    }
  },
  computed: {
    placeholder () {
      switch (this.component.archive.dataType) {
        case 'date':
          return '请输入日期'
        case 'time':
          return '请输入时间'
        case 'dateTime':
          return '请输入日期时间'
      }
    },
    pickerOptions () {
      return this.component.properties.pickerOptions || {}
    }
  },
  created () {
    this.formatValue = this.value
  },
  watch: {
    value () {
      this.formatValue = this.value
    },
    data: {
      handler (val) {
        this.value = val[this.column.id]
        this.error = ''
        this.edit = false
        this.getShowTooltip()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .report-column-edit-date {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    .span {
      font-size: 13px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 20px;
      height: 100%;
      line-height: 42px;
      span {
        font-size: 13px;
      }
      .el-icon-date {
        position: absolute;
        right: 3px;
        top: calc(50% - 7px);
        cursor: pointer;
        color: #C2C3C4;
        display: none;
        &:hover {
          color: #55acf1;
        }
        &:active {
          color: #3079df;
        }
      }
      &:hover {
        .el-icon-date {
          display: inline-block;
        }
      }
    }
    .date {
      width: 100%;
      height: 100%;
      .el-date-editor, .el-input {
        // .pagination-list .el-main .content .el-input 覆盖了
        width: 100% !important;
        height: 100%;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
        .el-input__inner {
          width: 100%;
          // .pagination-list .el-main .content .el-input .el-input__inner 这个样式覆盖了
          height: 100% !important;
          -webkit-border-radius: 0;
          -moz-border-radius: 0;
          border-radius: 0;
          font-size: 13px;
          color: #000;
          padding: 0!important;
          text-align: center;
        }
        .el-input__suffix {
          .el-input__suffix-inner {
            // .pagination-list .el-main .content .el-input.el-input--mini .el-input__icon
            .el-input__icon {
              height: 42px !important;
              line-height: 42px !important;
            }
          }
        }
      }
    }
    .error-message {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 2;
      background-color: #FEECEC;
      color: #F05459;
      border: 1px solid #F05459;
      padding: 0 5px;
      border-top: none;
      text-align: left;
      font-size: 12px;
    }
  }
  .error-border {
    .date {
      .el-input {
        .el-input__inner {
          border: 1px solid #F05459;
        }
      }
    }
  }
  .report-column-edit-column-normal {
    position: relative;
    .span{
      white-space: normal;
      line-height: 26px;
      padding: 5px 25px 5px 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/reportColumnEdit/rc-date.vue